module.exports = __webpack_public_path__ + "static/media/ic_arrow_down_white.9b741f5d.svg";